'use client';
import { memo } from 'react';
import type { ReactElement } from 'react';
import { motion } from 'framer-motion';
import { Ctext } from '../Ctext';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { HERO_ANIMATION } from './Chero.constants';
import { getHeroLogoAnimation, getHeroLogoContainerStyle, getHeroTextContainerStyle, getHeroTextMetrics, } from './Chero.styles';
interface CheroTextProps {
    isMobile: boolean;
    isLogoReady: boolean;
}
export const CheroText = memo(function CheroText({ isMobile, isLogoReady, }: CheroTextProps): ReactElement {
    const { logoNameSize, logoSuffixSize, taglineSize } = getHeroTextMetrics({
        isMobile,
    });
    return (
      <div data-el="Chero/Text/Root" style={getHeroTextContainerStyle()}>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{
            duration: HERO_ANIMATION.tagline.duration,
            ease: HERO_ANIMATION.ease,
        }} style={{ display: 'flex', willChange: 'opacity, transform' }}>
          <Ctext size={taglineSize} color={ColorType.White} weight={FontWeight.Medium} opacity={1} align="center" suppressHydrationWarning>
            Command the AI collective
          </Ctext>
        </motion.div>

        <motion.div style={{
            ...getHeroLogoContainerStyle(),
            willChange: 'opacity, transform',
        }} initial={{ opacity: 0, scale: 0.96 }} animate={getHeroLogoAnimation({ isLogoReady })} transition={{
            duration: HERO_ANIMATION.logo.duration,
            ease: HERO_ANIMATION.ease,
        }}>
          <Ctext size={logoNameSize} color={ColorType.Accent} weight={FontWeight.SemiBold} opacity={1} style={{ fontWeight: 600 }} suppressHydrationWarning>
            CABAL
          </Ctext>
          <Ctext size={logoSuffixSize} color={ColorType.White} weight={FontWeight.Medium} opacity={1} suppressHydrationWarning>
            AI
          </Ctext>
        </motion.div>
      </div>
    );
});
